export const languageChangerObject ={
	'italian': {
		'navigation': {
			0: '',
			1:'Menù',
			2:'Vini',
			3:'Consegna',

			4: 'Contatti',
		},
		'previewPage': {
			1: 'Piatti preparati su ordinazione',
			// 2: 'Enoteca',
			3: 'Catering per matrimoni, battesimi, onomastici e altri tipi di cerimonie. Consegna a Padova e nelle zone limitrofe.',
			4: 'Effettua un ordine',
			// 5: 'Officina affidabile nel centro di Chişinău!👌'
		},
		// 'whyUs': {
		// 	1: 'Perché scegliere noi?',
		// 	2: 'Prezzi ragionevoli',
		// 	3: 'Personale qualificato',
		// 	4: 'Garanzia personalizzata',
		// 	5: 'Utilizziamo ricambi nuovi per le riparazioni',
		// 	6: 'Percorso verso l’officina',
		// 	7: 'Recensioni dei clienti',
		// 	8: 'Vedi tutte le recensioni',
		// 	9: "Personale esperto",
		// 	10: "Personale qualificato",
		// 	11: "Ricambi di qualità per le riparazioni",
		// 	//12: "Magazzino ricambi proprio",
		// },
		'shortAdd': {
			1: 'Prenota una diagnostica completa del sistema di sovralimentazione',
			2: 'La tua auto ha perso vivacità? Prenota una diagnostica e controlleremo il tuo veicolo',
			3: 'Prenota ora',
		},
		// 'aboutUs': {
		// 	1: 'Informazioni sull’officina',
		// 	2: 'Turbo Wheel si specializza nella diagnostica, manutenzione e riparazione di turbocompressori per tutti i tipi di auto. La nostra esperienza e le tecnologie moderne ci permettono di risolvere anche i problemi più complessi, così che la tua turbina funzioni come nuova.',
		// 	3: '',
		// 	4: '',
		// 	4.1: '',
		// 	4.2: '',
		// 	5: '',
		// 	6: '',
		// 	7: '',
		// 	8: '',
		// 	listTitle: 'Servizi Turbo Wheel',
		// 	listItem1: 'Diagnostica della turbina e del turbocompressore',
		// 	listItem2: 'Smontaggio e montaggio di turbina e turbocompressore',
		// 	listItem3: 'Riparazione della turbina, sostituzione della turbina',
		// 	listItem4: 'Controllo del sistema del vuoto',
		// 	listItem5: 'Verifica della tenuta del sistema di aspirazione (fumatore di prova)',
		// 	listItem6: 'Diagnostica computerizzata e altri servizi in officina',
		// },
		'contactsPage': {
			'form': {
				1:'Scrivici della tua cerimonia e ti richiameremo',
				2:'Il tuo telefono*',
				3:'Nome',
				4:'Marcelo...',
				5:'Tipo di cerimonia',
				6:'Compleanno...',
				7:'Descrizione',
				8:'Esempio: Abbiamo bisogno di un tavolo con piccoli snack per 50 persone...',
				9: 'La tua richiesta è stata inviata con successo! Attendi la risposta.',
				10: 'Invia',
				11: '* Questo campo è obbligatorio',
			},
			'contacts': {
				1: 'Contatti',
				2: 'Italia, Padova',
				3: '...',
			}
		},
		// 'footer': {
		// 	1: 'Sito sviluppato con il supporto di',
		// 	2: ' con il supporto di '
		// }
	},
	'romanian':{
		'navigation':{
			0:'',
			1:'Meniu',
			2:'Vinuri' ,
			3:'Livrare',
			4:'Contacte',
		},
		'previewPage':{
			1:'Bucate la comandă',
			// 2:'Vinuri.',
			3:'Catering pentru nunți, cumetrii, zile onomastice și alte tipuri de ceremonii. Livrare în Padova și suburbii.',
			4:'Efectuaează comandă',
			// 5:'service auto de Încredere cu locație în Chișinău!'
		},
		// 'whyUs':{
		// 	1:'De ce trebuie să ne alegi?',
		// 	2:'Prețuri rezonabile',
		// 	3:'-',
		// 	4:'Personal calificat',
		// 	5:'Piese de schimb calitative',
		// 	6:'Vezi locația',
		// 	7:'Recenziile clienților',
		// 	8:'Toate recenziile',
		// 	9: "Specialiști cu experiență",
		// 	10: "Personal calificat",
		// 	11: "Piese de schimb calitative",
		// },
		// 'shortAdd':{
		// 	1:'Înscrie-te pentru verificarea completă a sistemului de admisie',
		// 	2:'Mașina deja nu e la fel de rapidă cum a fost? Înscrie-te pentru verificare și noi îți verificăm mașina',
		// 	3:'Înscriere',
		// },
		// 'aboutUs':{
		// 	1:'Despre autoservice',
		// 	2:'Turbo Wheel este specializat în diagnosticare și restaurare a turbocompresoarelor pentru toate tipurile de mașini. Experiența noastră și tehnologiile moderne ne permit să rezolvăm eficient chiar și cele mai complexe probleme, astfel încât turbina dvs. să funcționeze ca nouă.',
		// 	9:'Reparație calitativă a turbinei există.',
		// 	10:'',
		// 	listTitle:'Servicii Turbo Wheel',
		// 	listItem1:'Verificarea turbinei și turbocompresorului',
		// 	listItem2:'Demontarea și montarea turbinei și turbocompresorului',
		// 	listItem3:'Repararea turbinei, înlocuirea turbinei',
		// 	listItem4:'Verificarea sistemului de vacuum',
		// 	listItem5:'Verificarea sistemului de admisie',
		// 	listItem6:'Diagnosticare computerizată și alte servicii',
		// },
		'contactsPage':{
			'form':{
				1:'Scrie-ne despre ceremonia ta și te sunăm înapoi',
				2:'Telefonul tău*',
				3:'Nume',
				4:'Marcel...',
				5:'Tipul ceremoniei',
				6:'Zi de naștere...',
				7:'Descriere',
				8:'Exemplu: Avem nevoie de masă cu mici gustări, pentru 50 de oameni...',
				9:'Cererea ta a fost trimisă cu succes! Revenim cu un sunet',
				10:'Trimite',
				11:'* Este necesar să completezi măcar acest câmp'
			},
			'contacts':{
				1:'Contacte',
				2:'Italia, Padova',
				// 3:'info adăugător',
			}
		},
		// 'footer':{
		// 	1:'Site-ul a fost dezvoltat de către',
		// 	2:" cu suportul "
		// }
	}
}